<template>
  <button class="btn-component" type="button">
    <slot />
  </button>
</template>

<script>
export default {
  name: "makc-button"
};
</script>

<style scoped>
/*button {*/
/*  padding: 14px 32px;*/
/*  font-family: SourceSansPro, sans-serif;*/
/*  font-weight: 700;*/
/*  font-size: 20px;*/
/*  line-height: 20px;*/
/*  transition: background-color 0.2s;*/
/*  border: none;*/
/*  outline: none;*/
/*  cursor: pointer;*/
/*  min-width: 150px;*/
/*}*/

/*button.primary {*/
/*  background-color: #0075D4;*/
/*  color: white;*/
/*}*/

/*button.primary:hover {*/
/*  background-color: #008CFF;*/
/*}*/

/*button.primary:disabled {*/
/*  background-color: #ecebeb;*/
/*}*/

/*button.outline-primary {*/
/*  color: #0075D4;*/
/*  background-color: white;*/
/*  border: 1px solid #0075D4;*/
/*}*/

/*button.outline-primary:hover {*/
/*  background-color: #0075D4;*/
/*  color: white;*/
/*}*/

/*button.secondary {*/
/*  background-color: grey;*/
/*  color: black;*/
/*}*/

/*button.danger {*/
/*  background-color: #dc3545;*/
/*  color: white;*/
/*  border: 1px solid #dc3545;*/
/*}*/

/*button.danger:hover {*/
/*  color: #dc3545;*/
/*  background-color: white;*/
/*}*/

/*button.outline-danger {*/
/*  color: #dc3545;*/
/*  background-color: white;*/
/*  border: 1px solid #dc3545;*/
/*}*/

/*button.outline-danger:hover {*/
/*  background-color: #dc3545;*/
/*  color: white;*/
/*}*/

/*button.black {*/
/*  background-color: #0a0a0a;*/
/*  color: white;*/
/*}*/

/*button.outline-black {*/
/*  background-color: white;*/
/*  border: 1px solid #b8b8b8;*/
/*  color: black;*/
/*}*/
</style>